module.exports = __webpack_public_path__ + "img/9.c78630f5.gif";